<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ pageTitle }}</h2>
        <!-- //contents_head -->

        <!-- srchTop_wrap -->
        <div class="srchTop_wrap srch_mypage">
            <article class="srch_detail">
                <dl class="dl_select">
                    <dt class="text-bold">{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}<em class="txt_mandatory">*</em></dt>
                    <dd data-input-type="select">
                        <!-- 200715수정 S -->
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select
                                    id="SEL_REGION_CD"
                                    name="SEL_REGION_CD"
                                    v-model="SEL_REGION_CD"
                                    class="slt_white w100p"
                                    @change="changeRegionCd($event)"
                                >
                                    <option value="" disabled selected>{{ $t('FIELD.GLOBAL.SELECT') }}</option>
                                    <option v-for="(item, index) in selRegionList"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select
                                    id="SEL_CORP_CD"
                                    name="SEL_CORP_CD"
                                    v-model="SEL_CORP_CD"
                                    class="slt_white w100p"
                                    @change="changeCorpCd($event)"
                                >
                                    <option value="" disabled selected>{{ $t('FIELD.GLOBAL.SELECT') }}</option>
                                    <option v-for="(item, index) in selCorpList"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_select">
                    <dt>{{ $t('FIELD.GLOBAL.MENU') }}</dt>
                    <dd data-input-type="select">
                        <!-- 200715수정 S -->
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select
                                    id="BOARD_TYPE1"
                                    name="BOARD_TYPE1"
                                    v-model="BOARD_TYPE1"
                                    class="slt_white w100p"
                                    @change="changeBoardType1($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                    <option v-show="boardType1List.length > 0"
                                            v-for="item in boardType1List"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select
                                    id="BOARD_TYPE2"
                                    name="BOARD_TYPE2"
                                    v-model="BOARD_TYPE2"
                                    class="slt_white w100p"
                                    @change="changeBoardType2($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                    <option v-show="boardType2List.length > 0"
                                            v-for="item in boardType2List"
                                            :key="item.code"
                                            :value="item.code"
                                            :data-menu-grp-dtl-cd="item.menuGrpDtlCd"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_select">
                    <dt>{{ $t('FIELD.GLOBAL.CATEGORY') }}</dt>
                    <dd data-input-type="select">
                        <!-- 200715수정 S -->
                        <fieldset class="ui_fieldset set_3">
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD1"
                                        v-model="PRD_CATEGORY_CD1"
                                        @change="changeCategory1($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList1.length > 0"
                                            v-for="item in categoryComboList1"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD2"
                                        v-model="PRD_CATEGORY_CD2"
                                        @change="changeCategory2($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList2.length > 0"
                                            v-for="item in categoryComboList2"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD3"
                                        v-model="PRD_CATEGORY_CD3"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList3.length > 0"
                                            v-for="item in categoryComboList3"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_input">
                    <dt>{{ $t('FIELD.GLOBAL.ADDED.ON') }}</dt>
                    <dd data-input-type="date">
                        <fieldset class="ui_fieldset">
                            <span class="date-wrap">
                                <label>
                                    <input id="fromDate" type="text" class="date_input w100p" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                    <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                </label>
                                <div id="from-picker-container" style="margin-top: -1px;"/>
                            </span>
                            <em class="txt_space"></em>
                            <span class="date-wrap">
                                <label>
                                    <input id="toDate" type="text" class="date_input w100p" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                    <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                </label>
                                <div id="to-picker-container" style="margin-top: -1px;"/>
                            </span>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_search">
                    <dt>{{ $t('FIELD.GLOBAL.STATUS') }}</dt>
                    <dd data-input-type="select">
                        <select class="slt_white w100p"
                                id="searchStatus"
                                v-model="searchStatus"
                        >
                            <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                            <option v-show="statusComboList.length > 0"
                                    v-for="item in statusComboList"
                                    :key="item.code"
                                    :value="item.code"
                            >{{item.codeName}}</option>
                        </select>
                    </dd>
                    <dd class="clearable" data-input-type="input">
                        <input  id="searchTitle"
                                name="searchTitle"
                                type="text"
                                class="text_input w100p"
                                maxlength="200"
                                v-model.trim="searchTitle"
                                :placeholder="$t('FIELD.PLACEHOLDER.KNOWLEDGE.RESULTSEARCH')"
                                @keyup.enter.stop="handleSearch"
                                v-clearable
                        >
                        <i class="clearable_clear">{{ $t('BUTTON.GLOBAL.DELETE') }}</i>
                    </dd>
                </dl>
                <!-- 200714수정 S -->
                <span class="srch_mypage_btn">
                    <a href="javascript:" class="btn_srch" :title="$t('FIELD.GLOBAL.SEARCH')" @click="handleSearch">{{ $t('FIELD.GLOBAL.SEARCH') }}</a>
                </span>
            </article>
        </div>

        <!-- Grid -->
        <div class="grid_wrap" v-resize="setGridResizeColumn">
            <div v-show="getBoardCreationYN == 'Y'" class="btn_wrap">
                <a href="javascript:" class="btn_gray" :title="$t('BUTTON.GLOBAL.CREATE')" @click="createContents">{{ $t('BUTTON.GLOBAL.CREATE') }}</a>
            </div>
            <register-grid
                :gridId="gridId"
                :ref="gridId"
                :columns="columns"
                :data="gridData"
                :options="options"
                :pageOptions="pageOptions"
                :isTotalCount="true"
                :click="contentClick"
                @grid-total-count="setTotalCount"
            />
            <div class="paginate">
                <sdl-pagination
                    align="center"
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="movePage"
                />
            </div>
        </div>
    </div>
</div>
<!-- contents -->
</template>
<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import moment                               from 'moment';
import resize                               from 'vue-resize-directive'
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import SDLPagination                        from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import DatePicker                           from '~c/DatePicker';

import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';

import RegisterListGrid                     from './RegisterListGrid';
import RequestSharingFromPopup              from '~vb/common/RequestSharingFromPopup';

require('moment-jdateformatparser');

/**
 *  제목 및 아이콘
 *  Draft            : 작성 도중 임시 저장
 *  Request Sharing  : 메인과 동일 기준이며, H/R/N/U보다 우선 표시
 *  결재 진행 상태    : Complete은 1주일 후 사라지며 나머지는 지속적으로 표시됨.
 *  H/R/N/U          : 메인과 동일 기준
 *  콘텐트 선택       : 수정 버튼이 있는 콘텐트 상세 팝업 실행. 단 Request Sharing에 한해 공유 요청 팝업 실행
 *
 *  Icon 순서
 *  Request Sharing > 결재 (Processing/Complete/Rejected/Canceled) > H/R/N/U > FIX
 */

// Service Bulletin, Repair Tip, Repeated Repair Tip
const SCMS_CONTENTS_CD = [
    'SB',   // Service Bulletin
    'RT',   // Repair Tip
];

const fetchCodeCombo = (codeCategoryId, categoryId, symptomType, symptom1) => axios.get(
    `${SDLUtil.API_URL}/basis/common/codeAjax.skp?`
  + `codeCategoryId=${codeCategoryId}`
  + `&categoryId=${categoryId}`
  + `&symptomType=${symptomType}`
  + `&symptom1=${symptom1}`
  + `&parentCode=1`
);

// ToastGrid subject renderer
class CustomTitleRenderer {
    constructor(props) {
        const el = document.createElement('div');
        el.className = "tui-grid-cell-content";

        const em = document.createElement('em'),
              imEm = document.createElement('em');

        let title = props.value || 'Untitled';

        // Draft
        if(title.indexOf('@D@') > -1) {
            em.className = "textcolor_important";
            em.innerText = "["+ SDLUtil.getMsgProp('FIELD.GLOBAL.DRAFT') +"]";
            title = title.replace('@D@', '');
            el.appendChild(em);

        // Request Sharing
        } else if(title.indexOf('@Q@') > -1) {
            em.className = "textbox_request";
            em.innerText = SDLUtil.getMsgProp('FIELD.GLOBAL.REQUEST.SHARING');
            title = title.replace('@Q@', '');
            el.appendChild(em);

        // Hot
        } else if(title.indexOf('@R@') > -1) {
            em.className = "textbgbox_recommend";
            em.innerText = "R";
            title = title.replace('@R@', '');
            el.appendChild(em);

        // Read
        } else if(title.indexOf('@H@') > -1){
            em.className = "textbgbox_hot";
            em.innerText = "H";
            title = title.replace('@H@', '');
            el.appendChild(em);

        // New
        } else if(title.indexOf('@N@') > -1){
            em.className = "textbgbox_new";
            em.innerText = "N";
            title = title.replace('@N@', '');
            el.appendChild(em);

        // Update
        } else if(title.indexOf('@U@') > -1){
            em.className = "textbgbox_update";
            em.innerText = "U";
            title = title.replace('@U@', '');
            el.appendChild(em);
        /**
         * TODO 결재 진행 후 상태값에 따라 진행할 것
         */
        // Fix
        } else if(title.indexOf('@F@') > -1){
            em.className = "textbox_fix";
            em.innerText = SDLUtil.getMsgProp('FIELD.GLOBAL.FIX');
            title = title.replace('@F@', '');
            el.appendChild(em);
        }

        title = SDLUtil.convertHtml(title);
        el.appendChild(document.createTextNode(title));

        this.el = el;
    }

    getElement() {
        return this.el;
    }
};

export default {
    name: 'RegisterList',
    data() {
    	return {
            pageTitle: '',

            isRepair: false,            // Repair tip 메뉴 체크
            isSCMS: false,              // SCMS 체크
            isRhq: false,               // RHQ 체크

            SEL_REGION_CD: '',
            SEL_CORP_CD: '',
            selRegionList: [],
            selCorpList: [],

            BOARD_TYPE1: '',            // board Type - board parent id
            BOARD_TYPE2: '',            // board Type - board id
            boardType1List: [],         // board Type List 1
            boardType2List: [],         // board Type List 2
            isBoardReady: false,

            PRD_CATEGORY_CD1: '',       // Category 1
            PRD_CATEGORY_CD2: '',       // Category 2
            PRD_CATEGORY_CD3: '',       // Category 3
            categoryComboList1: [],     // Category 1 List
            categoryComboList2: [],     // Category 2 List
            categoryComboList3: [],     // Category 3 List
            qCategory1: '',             // Quick Category Value 1
            qCategory2: '',             // Quick Category Value 2
            qCategory3: '',             // Quick Category Value 3

            rangePicker: null,

            searchStatus: '',           // Status
            statusComboList: [],        // Status List

            searchTitle: '',            // Subject

            gridId: 'myKnowledgeGrid',
            columns: [],
            options: {},
            pageOptions: {},
            gridData: [],

            totalCount: 0,
            pageNo: 1,
            currentPage: 1,
            perPage: localStorage.getItem('listRows') ? Number(localStorage.getItem('listRows')) : 10
    	}
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq',
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
            locale: 'getLocale',
            menus: 'getMenus',
        }),
        getUserInfo()           { return SDLUtil.getLoginedUserInfo() || {}; },
        getUserRole()           { return this.userRoles || []; },
        getUserCorpCd()         { return this.userCorpCd || ''; },
        getBoardCreationYN()    { return this.params.creationYn || 'N'; },
        getScrapWorkCode()      { return MenuUtil.getScrapWorkCode(); },
        getLoginNo()            { return this.loginNo || ''; },
        getLoginRHQCd()         { return this.loginRhq || ''; },
        getSelCorpCd()          { return this.SEL_CORP_CD || ''; },
        getSelBoardType1()      { return this.BOARD_TYPE1 || ''; },
        getSelBoardType2()      { return this.BOARD_TYPE2 || ''; },
        getSelCategory1()       { return (!SDLUtil.isNull(this.qCategory1)) ? this.qCategory1 : this.PRD_CATEGORY_CD1 || ''; },
        getSelCategory2()       { return (!SDLUtil.isNull(this.qCategory2)) ? this.qCategory2 : this.PRD_CATEGORY_CD2 || ''; },
        getSelCategory3()       { return (!SDLUtil.isNull(this.qCategory3)) ? this.qCategory3 : this.PRD_CATEGORY_CD3 || ''; },
        getReSearch()           { return this.$route.query.reSearch || 'N'; },
        getPageNo()             { return this.pageNo; },
    },
    directives: { resize },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'sdl-pagination'    : SDLPagination,
        'register-grid'     : RegisterListGrid,
    },
    methods: {
        // 처음 로딩 시
        initLoad() {
            let that = this;
            SDLUtil.showLoadingBar(true);
            return new Promise(function(resolve) {
                // 그리드 컬럼 세팅
                that.columns = that.getDynamicCols();
                // 지역목록 로드 후 게시판 타입 1 로드
                that.setRegionList().then(() => {
                    that.setCorpList().then(() => {
                        that.setBoardType1().then(() => {
                            that.setBoardType2();
                        })
                    })
                });
                // 초기 카테고리1 리스트 로드
                that.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                    that.categoryComboList1 = data;
                });
                // 초기 상태 리스트 로드
                that.setStatusList();
                SDLUtil.showLoadingBar(false);

                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // Code combo list api
        async getCodeComboList(categoryVal, categoryCode, addCondition) {
            let additionalValue = (['RHQ_AUTH_ACCESS_CD', 'SUB_AUTH_ACCESS_CD'].includes(categoryCode)) ? this.getLoginNo : this.getUserCorpCd;
            // BOARD_TYPE2 의 경우, 선택된 corpCd 를 넘겨준다.
            if(categoryCode === 'BOARD_TYPE2') { additionalValue = this.getSelCorpCd; }
            const codeResp = await api.getComboList(categoryVal, categoryCode, additionalValue);
            return codeResp;
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        // 권한체크
        isAllUser(){
            if(
                this.getUserRole.includes(`${constants.SYSTEM_ADMIN}`)
             || this.getUserRole.includes(`${constants.GBM_ADMIN}`)
             || this.getUserRole.includes(`${constants.RHQ_ADMIN}`)
            ) {
                return true;
            } else {
                return false;
            };
        },
        setRegionList() {
            let that = this;
            return new Promise(function(resolve) {
                that.getCodeComboList(that.loginNo, "RHQ_AUTH_ACCESS_CD")
                    .then(data => {
                        that.selRegionList = data;
                        that.SEL_REGION_CD = that.getLoginRHQCd;
                        
                        setTimeout( function(){ resolve(); }, 100 );
                    });
            });
        },
        setCorpList() {
            let that = this;
            return new Promise(function(resolve) {
                that.getCodeComboList(that.getLoginRHQCd, "SUB_AUTH_ACCESS_CD")
                    .then(data => {
                        that.selCorpList = data;
                        that.SEL_CORP_CD = that.getUserCorpCd;

                        setTimeout( function(){ resolve(); }, 100 );
                    });
            });
        },
        // Board1 setting
        setBoardType1() {
            let that = this;
            return new Promise(function(resolve) {
                that.getCodeComboList(that.getSelCorpCd, "BOARD_TYPE1").then(data => {
                    that.BOARD_TYPE1    = that.getSelBoardType1;
                    that.boardType1List = data;

                    setTimeout( function(){ resolve(); }, 100 );
                });
            });
        },
        // Board2 setting
        setBoardType2() {
            let that = this;
            that.getCodeComboList(that.getSelBoardType1, "BOARD_TYPE2").then(data => {
                that.BOARD_TYPE2    = that.getSelBoardType2;
                that.boardType2List = data;
                that.isBoardReady   = true;
            });
        },
        // 지역 코드 변경 이벤트
        changeRegionCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue === "") {
                this.selCorpList = [], this.SEL_CORP_CD = '';
                this.boardType1List = [], this.BOARD_TYPE1 = '';
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "SUB_AUTH_ACCESS_CD").then(data => {
                    this.selCorpList = data, this.SEL_CORP_CD = '';
                    this.boardType1List = [], this.BOARD_TYPE1 = '';
                    this.boardType2List = [], this.BOARD_TYPE2 = '';
                });
            }
        },
        changeCorpCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue === "") {
                this.boardType1List = [], this.BOARD_TYPE1 = '';
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE1").then(data => {
                    this.boardType1List = data, this.BOARD_TYPE1 = '';
                    this.boardType2List = [],   this.BOARD_TYPE2 = '';
                });
            }
        },
        // Board1 combo change event => create Board2 combo list
        changeBoardType1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE2").then(data => {
                    this.boardType2List = data;
                    this.BOARD_TYPE2    = '';
                });
            }
        },
        // Board2 combo change event
        changeBoardType2(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue !== "") {
                let selMenuGrpDtlCd = document.getElementById('BOARD_TYPE2').selectedOptions[0].getAttribute('data-menu-grp-dtl-cd');
                this.setSCMSField(this.getMenuGrpDtlCd);

            } else {
                this.isSCMS = false;
            }
        },
        // SCMS 필드 사용 여부 + Repair tip 메뉴 여부
        setSCMSField(menuGroupDetailCd = this.params.menuGrpDetailCd) {
            // Service Bulletin, Repair Tip, Call Guide, Repeated Repair Tip => isSymptom true
            if(menuGroupDetailCd !== null) {
                // SCMS Contents 이어야 하고 Board 를 통한 접근이 아니어야 함
                if( _.includes(SCMS_CONTENTS_CD, menuGroupDetailCd)
                 && !this.isBoardAccess
                ) {
                    if(menuGroupDetailCd === 'RT') this.isRepair = true;
                    this.isSCMS = true;

                } else {
                    this.isRepair = false;
                    this.isSCMS = false;
                }

            } else {
                this.isRepair = false;
                this.isSCMS = false;
            }
        },
        // 첫번째 카테고리 설정
        setCategory1() {
            let that = this;
            return new Promise(function(resolve) {
                that.getCodeComboList(that.getSelCategory1, "ADM_CATEGORY_B").then(data => {
                    that.PRD_CATEGORY_CD1 = that.getSelCategory1;
                    that.categoryComboList2 = data;
                    
                    setTimeout( function(){ resolve(); }, 100 );
                });
            });
        },
        // 두번째 카테고리 설정
        setCategory2() {
            let that = this;
            return new Promise(function(resolve) {
                that.getCodeComboList(that.getSelCategory2, "ADM_CATEGORY_C").then(data => {
                    that.PRD_CATEGORY_CD2 = that.getSelCategory2;
                    that.categoryComboList3 = data;
                    that.PRD_CATEGORY_CD3 = that.getSelCategory3;
                    
                    setTimeout( function(){ resolve(); }, 100 );
                });
            });
        },
        // 첫번째 카테고리 변경 이벤트
        changeCategory1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList2 = [], this.PRD_CATEGORY_CD2 = '';
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
                for(let idx = 0; idx < this.symptomList.length; idx++){
                    this.symptomList[idx].SYMPTOM_TYPEList   = [], this.symptomList[idx].SYMPTOM_TYPE     = '';
                    this.symptomList[idx].SYMPTOM_TYPE1List  = [], this.symptomList[idx].SYMPTOM_TYPE1    = '';
                }

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_B").then(data => {
                    this.PRD_CATEGORY_CD2 = '';
                    this.categoryComboList2 = data;
                });

                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
            }
        },
        // 두번째 카테고리 변경 이벤트
        changeCategory2(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
                for(let idx = 0; idx < this.symptomList.length; idx++){
                    this.symptomList[idx].SYMPTOM_TYPEList   = [], this.symptomList[idx].SYMPTOM_TYPE     = '';
                    this.symptomList[idx].SYMPTOM_TYPE1List  = [], this.symptomList[idx].SYMPTOM_TYPE1    = '';
                }

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_C").then(data => {
                    this.PRD_CATEGORY_CD3 = '';
                    this.categoryComboList3 = data;
                });
            }
        },
        // Status Combo list
        setStatusList() {
            SDLUtil.getCommCodeList('KNOWLEDGE_STATUS').then(data => {
                this.searchStatus = '';
                this.statusComboList = data;
            });
        },
        // 그리드 컬럼 percent resize 용
        getDynamicCols() {
            return [
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MENU'), name: 'BOARD_TYPE', align: 'left', width: this.getColumnSize(15), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY'), name: 'PRD_CATEGORY_NM', align: 'left', width: this.getColumnSize(23), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'), name: 'MODEL', align: 'left', width: this.getColumnSize(12), resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT'), name: 'KNOWLEDGE_TITLE', align: 'left', width: this.getColumnSize(27), resizable: true, sortable: true, renderer: { type: CustomTitleRenderer } },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.STATUS'), name: 'KNOWLEDGE_STATUS', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.ADDED.ON'), name: 'REG_DT', align: 'center', width: this.getColumnSize(8), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.HIT'), name: 'HIT_COUNT', align: 'center', width: this.getColumnSize(5), resizable: true, sortable: true },
                { header: 'KNOWLEDGE_ID', name: 'KNOWLEDGE_ID', hidden: true },
                { header: 'BUG_REPORT_ID', name: 'BUG_REPORT_ID', hidden: true },
            ];
        },
        getColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('grid_wrap').length ? document.getElementsByClassName('grid_wrap')[0].clientWidth - 16 : 1000;
            return Math.floor(gridWrapSize / (100 / size));
        },
        setGridResizeColumn(e) {
            EventBus.$emit('reg-grid-set-column', this.getDynamicCols());
        },
        // 그리드 컬럼 percent resize 용

        // 페이지 이동
        movePage(pageNo) {
            this.currentPage = pageNo;
            this.handlePageSearch(pageNo);
        },
        // 총 합계 설정
        setTotalCount(totCnt) {
            this.totalCount = totCnt;
        },
        // 현재 페이지 설정
        setCurrentPage(page) {
            this.currentPage = page;
        },

        // Search Parameter setting
        setSearchParameter() {
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            this.searchTitle = (SDLUtil.nvl(this.searchTitle)).toUpperCase();

            if(SDLUtil.isNull(this.getSelCorpCd)) {
                return SDLUtil.alert('MESSAGE.GROBAL.SELECT.SUBSIDIARY');
            };

            return {
                selectCorpNo: this.getSelCorpCd,
                BOARD_TYPE1: this.getSelBoardType1,
                BOARD_TYPE2: this.getSelBoardType2,
                PRD_CATEGORY_CD1: this.PRD_CATEGORY_CD1 || '',
                PRD_CATEGORY_CD2: this.PRD_CATEGORY_CD2 || '',
                PRD_CATEGORY_CD3: this.PRD_CATEGORY_CD3 || '',
                searchFromAddDt: this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                searchToAddDt: this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : '',
                searchStatus: this.searchStatus,
                searchTitle: this.searchTitle,
                ORDER_COLUMN: this.ORDER_COLUMN || '',
                ORDER_ASC: this.ORDER_ASC || '',
                page: this.getPageNo
            }
        },
        // 정렬 조회 - 정렬로 조회하는 경우, 페이지를 1로 초기화 한다.
        handleSortSearch(sortObj) {
            if(!SDLUtil.isNull(sortObj.orderColName)) {
                this.ORDER_COLUMN = sortObj.orderColName;
                this.ORDER_ASC = sortObj.ascending ? "ASC" : "DESC";
            } else {
                this.ORDER_COLUMN = '';
                this.ORDER_ASC = '';
            }

            this.handlePageSearch(1);
        },
        // 페이지 조회
        handlePageSearch(pageNo){
            if(pageNo !== null && pageNo != "") {
                this.pageNo = pageNo;
                this.handleSearch();

            } else {
                Vue.$log.warn('Page no is null');
            }
        },
        // 조회
        handleSearch() {
            // Call KnowledgeListGrid.vue > loadData method
            EventBus.$emit('reg-grid-search', this.setSearchParameter());
        },
        // 재조회
        reSearch(pageNo) {
            // this.setCategoryParam(boardParam.searchParams);
            this.pageNo = pageNo;
            this.handlePageSearch(pageNo);
        },
        // 컨텐츠 클릭 이벤트
        contentClick(e, rowData, grid) {
            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
            let row = rowData.find(function(r){ return r.rowKey === e.rowKey });
            let KNOWLEDGE_ID = row['KNOWLEDGE_ID'] || '',
                SHARE_ID = row['SHARE_ID'] || '';

            // request sharing 컨텐츠인 경우
            if(!SDLUtil.isNull(SHARE_ID)) {
                let sharingParams = {
                    knowledgeId: KNOWLEDGE_ID, shareId: SHARE_ID,
                    rtnFunc: (result) => {
                        this.handleSearch();
                    }
                };

                SDLUtil.show(
                    RequestSharingFromPopup,
                    sharingParams,
                    { height: 'auto' }
                );

            } else {
                Vue.$log.info('▶ RegisterList.vue contentClick event. =>', row, KNOWLEDGE_ID);
                store.commit('POPUP_PARAMS', { knowledgeId : KNOWLEDGE_ID });
                this.openDetailPop();
            }
        },
        // 컨텐츠 생성
        createContents() {
            store.commit('POPUP_PARAMS', { knowledgeId : '' });
            this.openDetailPop();
        },
        openDetailPop() {
            let linkUrl = MenuUtil.getRedirectUrl('/basis/myKnowledge/myKnowledge/register/registerForm');
            const detailPop = SDLUtil.openLegacyWindowPopup({
                url: linkUrl,
                title: SDLUtil.getMsgProp('TITLE.KNOWLEDGE.DETAIL'),
                w: 1366,
                h: 768
            });

            // 팝업이 닫히면 자동으로 리스트로 이동
            let self = this,
                popTimer = window.setInterval(function() {
                if (detailPop.closed !== false) { // !== is required for compatibility with Opera
                    window.clearInterval(popTimer);
                    self.handleSearch();
                }
            }, 200);
        },

        // Quick Category Parameter setting
        setQuickCategoryParam(catForm) {
            this.initCategoryParam();
            this.qCategory1 = catForm.searchPRD_CATEGORY_CD1;
            this.qCategory2 = catForm.searchPRD_CATEGORY_CD2;
            this.qCategory3 = catForm.searchPRD_CATEGORY_CD3;

            this.changeCategories();
        },
        // 카테고리 파라미터 초기화
        initCategoryParam() {
            this.qCategory1 = '';
            this.qCategory2 = '';
            this.qCategory3 = '';
            this.PRD_CATEGORY_CD1 = '';
            this.PRD_CATEGORY_CD2 = '';
            this.PRD_CATEGORY_CD3 = '';
            this.categoryComboList1 = [];
            this.categoryComboList2 = [];
            this.categoryComboList3 = [];
        },
        // 모든 카테고리 변경 이벤트, 처음 Mounted 혹은, quick category 를 click 했을 때 호출
        changeCategories() {
            this.setCategory1().then(() => {
                this.setCategory2().then(() => {
                    this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                        this.categoryComboList1 = data;
                    });
                });
            });
        },
    },
    created() {
        this.initLoad().then(() => {
            Vue.$log.info('▶ RegisterList.vue created.');
            EventBus.$on('page-search',    pageNo   => { this.handlePageSearch(pageNo); });
            EventBus.$on('sort-search',    sortForm => { this.handleSortSearch(sortForm); });
            EventBus.$on('quick-category', catForm  => { this.setQuickCategoryParam(catForm); });
        });
    },
    mounted() {
        // DOM 생성 후 이벤트
        this.$nextTick(() => {
            this.rangePicker = DatePicker.createRangeWithOpener(
                'from-picker-container', 'fromDate', 'icoFromDate',
                'to-picker-container', 'toDate', 'icoToDate',
                { type: 'date', locale: 'en', showToday: false },
                (new moment()).add(-1, 'years').toDate(),
                (new moment()).toDate()
            );

            /*
            this.searchRegion = this.$route.query.searchRegion;
            this.searchCorpNo = this.$route.query.searchCorpNo;
            this.searchFromDt = this.$route.query.searchFromDt;
            this.searchToDt = this.$route.query.searchToDt;
            this.searchTitle = this.$route.query.searchTitle;
            */
        });
    },
    beforeDestroy(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('page-search');
        EventBus.$off('sort-search');
        EventBus.$off('quick-category');
    }
};
</script>

<style>
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/myKnowledge/myKnowledge/RegisterList.vue